module.exports = __webpack_public_path__ + "media/images/games/35gender/footballplayer-0c6556013fa0c6ca91496c06ff2688ed.png";